import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'
import dayjs from 'dayjs'
import type { Suspension } from '../../hooks/useUsersMeSuspensions'

/**
 * Fetches the logged-in user's suspensions (optionally only active ones),
 * sorted ascending by end date. User-level — not scoped to a player.
 */
export const getUserSuspensions = async (
  onlyActive = false
): Promise<Suspension[]> => {
  const response = await req(
    `${ENDPOINTS.USERS.GET_MY_SUSPENSIONS()}?active_suspensions=${
      onlyActive ? 1 : 0
    }`
  )

  const rows: Suspension[] = Array.isArray(response?.data) ? response.data : []

  return [...rows].sort((a, b) => {
    const dateA = dayjs(a.end_date)
    const dateB = dayjs(b.end_date)
    if (dateA.isBefore(dateB)) {
      return -1
    }
    if (dateA.isAfter(dateB)) {
      return 1
    }
    return 0
  })
}
